/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://o5ibo5vzovcvtf3bqwf4ns73ry.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-624a5avukrbnzcazhla5uizb2q",
    "aws_cognito_identity_pool_id": "us-west-2:2fc135fa-e34b-438e-bde4-6cccf84d6da7",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_ACxGmk4lA",
    "aws_user_pools_web_client_id": "2fmpj39thooacvq3me23k9cind",
    "oauth": {
        "domain": "wednesdayclub.auth.us-west-2.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
